import { doc, getDoc, setDoc, deleteDoc, serverTimestamp } from 'firebase/firestore'
import { db } from '@/firebase'
import { RULE_EXPECTATIONS, attempt, accessDetail, fmtExpected } from '../ruleExpectations.js'

// genEdHours is Cloud-Function-maintained. Client write is always denied.
// Read is admins / full-read / any CM / speech CM, or the teacher's own doc.
// The write target is a fake teacher id so a real teacher's hours are never
// overwritten if a rule ever regresses to allow.

export default {
  id: 'genEdHours',
  label: 'Gen-ed hours read / function-only write',
  description:
    'genEdHours writes stay Cloud-Function-only; read of own vs another teacher matches the rules.',
  destructive: true,

  async run(ctx, step) {
    const role = ctx.roleClaim
    const otherId = `smoke_hours_${ctx.runId.slice(-8)}`
    const otherRef = doc(db, 'genEdHours', otherId)
    const ownRef = doc(db, 'genEdHours', ctx.user.uid)
    const expectWrite = RULE_EXPECTATIONS.genEdHoursWrite()
    const expectOwn = RULE_EXPECTATIONS.genEdHoursRead(role, { isOwn: true })
    const expectOther = RULE_EXPECTATIONS.genEdHoursRead(role, { isOwn: false })

    try {
      await step(
        `write other-teacher gen-ed hours (expected: ${fmtExpected(expectWrite)})`,
        async () => {
          const { allowed } = await attempt(() =>
            setDoc(otherRef, {
              teacherId: otherId,
              hours: 0,
              __smokeTest: true,
              __smokeRunId: ctx.runId,
              createdAt: serverTimestamp(),
              ...(ctx.schoolId ? { schoolId: ctx.schoolId } : {})
            })
          )
          if (allowed) await deleteDoc(otherRef).catch(() => {})
          return allowed
            ? `${accessDetail(expectWrite, allowed)} — genEdHours/${otherId}`
            : accessDetail(expectWrite, allowed)
        }
      )

      await step(`read own gen-ed hours (expected: ${fmtExpected(expectOwn)})`, async () => {
        const { allowed } = await attempt(() => getDoc(ownRef))
        return accessDetail(expectOwn, allowed)
      })

      await step(
        `read other-teacher gen-ed hours (expected: ${fmtExpected(expectOther)})`,
        async () => {
          const { allowed } = await attempt(() => getDoc(otherRef))
          return accessDetail(expectOther, allowed)
        }
      )
    } finally {
      await deleteDoc(otherRef).catch(() => {})
    }
  }
}
